/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Error_Pleasetryagainlater3Inputs */

const en_analytics_error_pleasetryagainlater3 = /** @type {(inputs: Analytics_Error_Pleasetryagainlater3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please`)
};

/**
* | output |
* | --- |
* | "Please" |
*
* @param {Analytics_Error_Pleasetryagainlater3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const analytics_error_pleasetryagainlater3 = /** @type {((inputs?: Analytics_Error_Pleasetryagainlater3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Error_Pleasetryagainlater3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_analytics_error_pleasetryagainlater3(inputs)
});
export { analytics_error_pleasetryagainlater3 as "analytics_error_pleaseTryAgainLater" }